import CompanyAPI from 'dashboard/api/companies';
import ContactAPI from 'dashboard/api/contacts';

const FIELD_APIS = {
  company_id: CompanyAPI,
  contact_id: ContactAPI,
};

const collectIdsForField = (events, field) => {
  const ids = new Set();
  events.forEach(event => {
    const change = event.changes?.[field];
    if (change === undefined) return;
    const values = Array.isArray(change) ? change : [change];
    values.forEach(value => {
      if (value !== null && value !== undefined) ids.add(value);
    });
  });
  return Array.from(ids);
};

const fetchNamesFor = async (api, ids) => {
  const map = new Map();
  await Promise.all(
    ids.map(async id => {
      try {
        const { data } = await api.show(id);
        map.set(id, data.payload?.name ?? id);
      } catch {
        // Registro apagado/inacessivel: mantem o id bruto como fallback.
      }
    })
  );
  return map;
};

// Varre os eventos da timeline em busca de company_id/contact_id
// alterados e resolve os nomes correspondentes de uma vez so, para
// exibir "Empresa X" em vez do id bruto no Historico.
export async function resolveTimelineFieldNames(events) {
  const result = {};
  await Promise.all(
    Object.entries(FIELD_APIS).map(async ([field, api]) => {
      const ids = collectIdsForField(events, field);
      result[field] = ids.length ? await fetchNamesFor(api, ids) : new Map();
    })
  );
  return result;
}
